export const Story = () => {
    return (
        <section
            id="drink"
            data-testid="story-section"
            className="relative px-6 sm:px-10 py-24 sm:py-32 overflow-hidden"
        >
            {/* Bull logo watermark */}
            <img
                src="https://customer-assets.emergentagent.com/job_mad-drinks/artifacts/35o1dtom_ChatGPT%20Image%2020.%206.%202026%2C%2009_50_18.png"
                alt=""
                aria-hidden="true"
                className="absolute -right-32 sm:-right-20 top-1/2 -translate-y-1/2 w-[420px] sm:w-[560px] opacity-10 pointer-events-none select-none"
            />

            <div className="relative max-w-[1400px] mx-auto grid grid-cols-12 gap-10">
                <div className="col-span-12 lg:col-span-3">
                    <div className="text-[11px] uppercase tracking-[0.3em] text-[#D91C1C]">
                        01 / Príbeh
                    </div>
                </div>

                <div className="col-span-12 lg:col-span-9">
                    <h2
                        data-testid="story-heading"
                        className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.9] text-white"
                    >
                        Vyrobený v kuchyni.{" "}
                        <span className="text-white/40">
                            Testovaný na odvážnych.
                        </span>
                    </h2>

                    <div className="mt-12 grid sm:grid-cols-2 gap-10 max-w-4xl">
                        <p
                            data-testid="story-paragraph-1"
                            className="text-lg text-white/70 leading-relaxed"
                        >
                            MAD začal ako čudný experiment v obyčajnej kuchyni
                            s pár zvláštnymi fľašami, tvrdohlavým nápadom a
                            nulovým rešpektom voči pravidlám
                            &bdquo;normálnych&ldquo; nápojov.
                        </p>
                        <p
                            data-testid="story-paragraph-2"
                            className="text-lg text-white/70 leading-relaxed"
                        >
                            Jeden recept. Jedna malá séria. Žiadne focus
                            groupy. Žiadna veľká továreň. Iba nápoj, ktorý
                            chutí, akoby niečo znamenal — pretože ho niekto
                            naozaj vyrobil.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
